import React, { useEffect } from 'react';
import solutionPossession1 from '../../img/solution_possession-1.png';
import solutionPossession2 from '../../img/solution_possession-2.png';
import solutionPossession3 from '../../img/solution_possession-3.png';
import solutionPossession4 from '../../img/solution_possession-4.png';
import '../../css/remixicon/remixicon.css'; 
import 'aos/dist/aos.css'; 

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const SolutionPoss = () => {

    return(
        <React.Fragment>
            <section className="about-cert">
                <div className="area">

                    <div className="solution-card">
                        <div className="solution-left">
                            <h3 className="solution-title">WIZ-FLOW</h3>
                            <p className="solution-desc1"> 
                                말로만 전달되던 현장 업무를 <br/> 
                                <span>시스템으로 지시하고, 실행 결과까지 남겨<br/> 
                                누락 없이 관리하는 솔루션</span>
                            </p>
                            <p className="solution-desc2">
                                현장에서 해야 할 일을 빠르게 공유하고, 누가 무엇을 했는지 바로 확인 가능<br/>
                                자율운영, 면담, 교육, Patrol 등 현장 운영활동을 체계적으로 관리<br/>
                                업무 누락 방지, 현장 실행력 강화, 표준화된 운영체계 구축에 기여
                            </p>
                        </div>
                        <div className="solution-right">
                            <img src={solutionPossession1} alt=''/>
                        </div>
                    </div>

                    <div className="solution-card">
                        <div className="solution-right">
                            <img src={solutionPossession2} alt=''/>
                        </div>
                        <div className="solution-left">
                            <h3 className="solution-title">WIZ-FACT</h3>
                            <p className="solution-desc1">
                                점검이 보여주기로 끝나지 않고, 이상사항을 <br/>
                                기록하고 끝까지 관리해 <br/>
                                <span>실제 개선으로 이어지게 하는 솔루션</span>
                            </p>
                            <p className="solution-desc2">
                                제조 현장의 점검 항목, 조직, 사용자 권한을 체계적으로 관리하는 점검 운영 솔루션 <br/>
                                점검결과 등록, 현황 모니터링, 이슈 확인, 추이 분석 기능을 통해 관리 효율 향상<br/>
                                데이터 기반 점검관리와 자동메일링으로 신속한 공유 체계 구축을 지원<br/>
                                점검 프로세스 표준화와 지속적인 현장 개선 활동에 기여
                            </p>
                        </div>
                    </div>

                    <div className="solution-card">
                        <div className="solution-left">
                            <h3 className="solution-title">WIZ-라벨발행시스템</h3>
                            <p className="solution-desc1">
                                <span>라벨 관련 업무를 현장에서 정확하게 처리</span> 하고, <br/>
                                문제 발생 시 후속 조치까지 놓치지 않도록 관리하는 솔루션
                            </p>
                            <p className="solution-desc2">
                                라벨 등록, 검토, Follow-up, Monitoring, 공통코드 관리 기능을 통해 업무 흐름을 체계적으로 지원<br/>
                                라벨 운영 이력과 조치 현황을 한눈에 관리하여 현장 대응 속도와 정확도를 향상<br/>
                                출하 혼선 감소, 추적성 강화 및 라벨 운영 표준화에 기여<br/>
                            </p>
                        </div>
                        <div className="solution-right">
                            <img src={solutionPossession3} alt=''/>
                        </div>
                    </div>

                    <div className="solution-card">
                        <div className="solution-right">
                            <img className='pop' src={solutionPossession4} alt=''/>
                        </div>
                        <div className="solution-left">
                            <h3 className="solution-title">WIZ-POP시스템</h3>
                            <p className="solution-desc1">
                                생산라인에서 작업, 검사, 라벨 처리, 완료 업무를 <br/>
                                바로 처리해 <span>공정 흐름을 통합 관리하는 솔루션</span>
                            </p>
                            <p className="solution-desc2">
                                생산계획부터 작업 입력, 검사, 완료, 모니터링까지 현장에서 실시간 처리 가능<br/>
                                라벨 발행·재발행, 매칭 기능으로 작업 정확도 향상<br/>
                                공정 이력 확보, 현장 혼선 감소, 생산 가시성 향상에 기여<br/>
                            </p>
                        </div>
                    </div>

                </div>
            </section>
        </React.Fragment>
    );
};

export default SolutionPoss;